// import { ACTIVE_ROW_CLASSNAME } from '../dictionaries/car'

const toggleRowClass = (el, className, add = true) => {
  if (!el) return

  if (add) {
    el.classList.add(className)
  } else {
    el.classList.remove(className)
  }
}

export {
  toggleRowClass
}
